<!--
 * @Description: 
 * @Author: luckymiaow
 * @Date: 2022-04-26 18:07:10
 * @LastEditors: luckymiaow
-->
<script setup lang="ts">
import { ConfigProvider as AConfigProvider } from 'ant-design-vue';
import { computed, useAttrs } from 'vue';
import type { ConfigProvider } from '../types';
import type { IStandardProps } from '../../standard/types';
import type { IUpload } from '../../upload/types';
import type { AuthorImgInjectConfig } from '../../auth-img/types';
import useConfigProvider from './useConfigProvider';
import type { Props as ConfigModal } from '../../modal/types';

interface IProp extends ConfigProvider {
  modal?: Partial<ConfigModal>;
  standard?: Partial<IStandardProps>;
  upload?: Partial<IUpload>;
  authorImg?: Partial<AuthorImgInjectConfig>;
  image?: Partial<AuthorImgInjectConfig>;
}

const props = defineProps<IProp>();

const attrs = useAttrs();

const obj = computed(() => {
  return {
    ...props,
    ...attrs,
  };
});

const { provideConfig } = useConfigProvider();

provideConfig(obj);
</script>

<template>
  <AConfigProvider v-bind="$attrs">
    <slot></slot>
  </AConfigProvider>
</template>
